import { render } from "./WorkFormInvoicingCard.vue?vue&type=template&id=38f4a2d2"
import script from "./WorkFormInvoicingCard.vue?vue&type=script&lang=js"
export * from "./WorkFormInvoicingCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__